import { BoltIcon, BriefcaseIcon, ClockIcon } from "@heroicons/react/24/solid";

export const listReasonsBookeeping = [
  {
    icon : () => {return (<BriefcaseIcon className="w-full"/>)},
    slug : "bookeeping_list_reason_slug_one",
    title: "bookeeping_list_reason_title_one",
    description: "bookeeping_list_reason_description_one"
  },
  {
    icon : () => {return (<BoltIcon className="w-full"/>)},
    slug : "bookeeping_list_reason_slug_two",
    title: "bookeeping_list_reason_title_two",
    description: "bookeeping_list_reason_description_two"
  },
  {
    icon : () => {return (<ClockIcon className="w-full"/>)},
    slug : "bookeeping_list_reason_slug_three",
    title: "bookeeping_list_reason_title_three",
    description: "bookeeping_list_reason_description_three"
  }
]